import { styled } from '@styles';
import { css } from 'styled-components';

import { PopoverTypes } from './types';

const filled = css<PopoverTypes>`
  ${({ theme }) => css`
    border: ${theme.popover.borderWidth} solid ${theme.popover.borderColor};
    border-radius: ${theme.popover.borderRadius};
    background: ${theme.popover.backgroundColor};
    box-shadow: ${theme.popover.shadow};
    color: ${theme.colors.white};

    .primitive-overlay {
      font-family: ${theme.typography.baseFontFamily};
      font-size: ${theme.typography.smallFontSize};
      line-height: ${theme.typography.baseLineHeight};
      padding: ${theme.popover.padding};
    }

    .arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-left: ${theme.popover.arrowSize} solid transparent;
      border-right: ${theme.popover.arrowSize} solid transparent;
      border-bottom: ${theme.popover.arrowSize} solid
        ${theme.popover.borderColor};

      &::after {
        position: absolute;
        content: ' ';
        width: 0;
        height: 0;
        top: 3px;
        left: calc(50% - ${theme.popover.arrowSize});
        border-left: ${theme.popover.arrowSize} solid transparent;
        border-right: ${theme.popover.arrowSize} solid transparent;
        border-bottom: ${theme.popover.arrowSize} solid
          ${theme.popover.backgroundColor};
        clip-path: inset(0 0 2px);
      }
    }
  `}
`;

const outline = css<PopoverTypes>`
  ${({ theme }) => css`
    border: ${theme.popover.borderWidth} solid ${theme.colors.red};
    border-radius: ${theme.popover.borderRadius};
    background: ${theme.colors.white};
    box-shadow: ${theme.popover.shadow};
    color: ${theme.colors.baseFontColor};

    .primitive-overlay {
      font-family: ${theme.typography.baseFontFamily};
      font-size: ${theme.typography.smallFontSize};
      line-height: ${theme.typography.baseLineHeight};
      padding: ${theme.popover.padding};
    }

    .arrow {
      display: none;
    }
  `}
`;

const appearances = {
  filled,
  outline,
};

export const Popover = styled.div<PopoverTypes>`
  ${({ appearance }) => css`
    ${appearance && appearances[appearance]}
  `}
`;
